import securityService from "core/services/securityService/securityService";
import PredefinedComponent from "./predefinedComponent";
import PredefinedComponentGroup from "./predefinedComponentGroup";
import ComponentNames from "../../../../../resources/generated/components.json";
import { ComponentKeys } from "../../../../../core/services/componentService/component-service";
import predefinedComponentProcessor from "../nodeProcessing/predefinedComponentProcessor";
import securityCheck from "../../../../../core/services/securityService/adapter-license-check";
import utils from "core/utils";
import { addonFeaturesKeys } from "../../../../../src/modules/user-plan/pages/user-plan/tabs/user-plan/components/add-on-features/add-on-features-utils";
import _ from "lodash";

const PredefinedComponentsDataSource = {
    load: function() {
        var collection = new PredefinedComponent.Collection();

        var agentsGroup = collection.add(
            new PredefinedComponentGroup({
                id: "agentsGroup",
                name: "AI Agents"
            })
        );
        // Create Sentinel component that functions like TransformationSentinel
        agentsGroup.components.add(createProcessingModel(ComponentNames.TransformationSentinel, "CQ"));

        // Create Foreseer component for time series forecasting
        agentsGroup.components.add(createProcessingModel(ComponentNames.Foreseer, "CQ"));
        // Create Euclid component for vector embeddings generation
        agentsGroup.components.add(createProcessingModel(ComponentNames.Euclid, "CQ"));

        agentsGroup.components.add(createProcessingModel(ComponentNames.Sherlock, "CQ"));
        agentsGroup.isExpanded = false;

        var inputGroup = collection.add(
            new PredefinedComponentGroup({
                id: "inputGroup",
                name: "Sources"
            })
        );
        let licensingOptions = securityService.licensingOptions;
        let isCosmosLicense = licensingOptions.indexOf("AzureCosmosDB") !== -1;

        inputGroup.components.add(createSourceModel(ComponentNames.ApacheAccessLog));
        inputGroup.components.add(createSourceModel(ComponentNames.Avro));
        inputGroup.components.add(createSourceModel(ComponentNames.Binary));
        inputGroup.components.add(createSourceModel(ComponentNames.CobolCopybookParser));
        inputGroup.components.add(createSourceModel(ComponentNames.CosmosDBReader));
        inputGroup.components.add(createSourceModel(ComponentNames.CollectD));
        inputGroup.components.add(createSourceModel(ComponentNames.DatabaseSource));
        inputGroup.components.add(createSourceModel(ComponentNames.DelimiterSeparatedValues));
        inputGroup.components.add(createSourceModel(ComponentNames.File));
        inputGroup.components.add(createSourceModel(ComponentNames.FreeFormText));
        inputGroup.components.add(createSourceModel(ComponentNames.GCSReader));
        inputGroup.components.add(createSourceModel(ComponentNames.GGTrail));
        inputGroup.components.add(createSourceModel(ComponentNames.GoldenGate));
        inputGroup.components.add(createSourceModel(ComponentNames.GoogleAdsReader));
        inputGroup.components.add(createSourceModel(ComponentNames.HDFS));
        inputGroup.components.add(createSourceModel(ComponentNames.HPNonStopCDC));
        inputGroup.components.add(createSourceModel(ComponentNames.HPNonStopSQLMP));
        inputGroup.components.add(createSourceModel(ComponentNames.HPNonStopSQLMX));
        inputGroup.components.add(createSourceModel(ComponentNames.Http));
        inputGroup.components.add(createSourceModel(ComponentNames.HubSpotReader));
        inputGroup.components.add(createSourceModel(ComponentNames.JiraReader));
        inputGroup.components.add(createSourceModel(ComponentNames.JMS));
        inputGroup.components.add(createSourceModel(ComponentNames.JMXReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MariaDBReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MariaDBXpandReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MariaDBIL));
        inputGroup.components.add(createSourceModel(ComponentNames.JSON));
        inputGroup.components.add(createSourceModel(ComponentNames.Kafka));
        inputGroup.components.add(createSourceModel(ComponentNames.MapRFSReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MongoDBReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MongoCosmosDBReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MQTT));
        inputGroup.components.add(createSourceModel(ComponentNames.MSSQLCDC));
        inputGroup.components.add(createSourceModel(ComponentNames.MSSQLIL));
        inputGroup.components.add(createSourceModel(ComponentNames.MSJet));
        inputGroup.components.add(createSourceModel(ComponentNames.MultiFileReader));
        inputGroup.components.add(createSourceModel(ComponentNames.MySQLCDC));
        inputGroup.components.add(createSourceModel(ComponentNames.MySQLIL));
        inputGroup.components.add(createSourceModel(ComponentNames.NameValuePair));
        inputGroup.components.add(createSourceModel(ComponentNames.NetFlow));
        inputGroup.components.add(createSourceModel(ComponentNames.OPCUAReader));
        inputGroup.components.add(createSourceModel(ComponentNames.IncrementalBatchReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SpannerBatchReader));
        inputGroup.components.add(createSourceModel(ComponentNames.OracleCDC));
        inputGroup.components.add(createSourceModel(ComponentNames.OJet));
        inputGroup.components.add(createSourceModel(ComponentNames.OracleIL));
        inputGroup.components.add(createSourceModel(ComponentNames.MariaDBXpandIL));
        inputGroup.components.add(createSourceModel(ComponentNames.PostgreSQLReader));
        inputGroup.components.add(createSourceModel(ComponentNames.PostgreSQLIL));
        inputGroup.components.add(createSourceModel(ComponentNames.S3Reader));
        inputGroup.components.add(createSourceModel(ComponentNames.Salesforce));
        inputGroup.components.add(createSourceModel(ComponentNames.SalesforcePushTopic));
        inputGroup.components.add(createSourceModel(ComponentNames.SalesforcePlatformEvent));
        inputGroup.components.add(createSourceModel(ComponentNames.ServiceNowReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SalesforcePardotReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SnowflakeCDCReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SNMP));
        inputGroup.components.add(createSourceModel(ComponentNames.TCP));
        inputGroup.components.add(createSourceModel(ComponentNames.UDP));
        inputGroup.components.add(createSourceModel(ComponentNames.WindowsEventLog));
        inputGroup.components.add(createSourceModel(ComponentNames.XML));
        inputGroup.components.add(createSourceModel(ComponentNames.XMLParserV2));
        inputGroup.components.add(createSourceModel(ComponentNames.SalesforceCDCReader));
        inputGroup.components.add(createSourceModel(ComponentNames.ZendeskReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SnowflakeILReader));
        inputGroup.components.add(createSourceModel(ComponentNames.Db2zOSIL));
        inputGroup.components.add(createBaseModel(ComponentNames.BaseExternalSource, "EXTERNALSOURCE"));
        inputGroup.components.add(createBaseModel(ComponentNames.BaseSource, "SOURCE"));
        //DO-NOT-REMOVE-BELOW-COMMENT
        //add-new-reader
        inputGroup.components.add(createSourceModel(ComponentNames.MicrosoftDynamics365Reader));
        inputGroup.components.add(createSourceModel(ComponentNames.MicrosoftDynamics365BusinessCentralReader));
        inputGroup.components.add(createSourceModel(ComponentNames.YugabyteCDC));
        inputGroup.components.add(createSourceModel(ComponentNames.YugabyteDBReader));
        inputGroup.components.add(createSourceModel(ComponentNames.BambooHrReader));
        inputGroup.components.add(createSourceModel(ComponentNames.GoogleSheetsReader));
        inputGroup.components.add(createSourceModel(ComponentNames.BigQueryILReader));
        inputGroup.components.add(createSourceModel(ComponentNames.LinkedInAdsReader));
        inputGroup.components.add(createSourceModel(ComponentNames.StripeReader));
        inputGroup.components.add(createSourceModel(ComponentNames.ADLSReader));
        inputGroup.components.add(createSourceModel(ComponentNames.IntercomReader));
        inputGroup.components.add(createSourceModel(ComponentNames.GoogleAnalyticsReader));
        inputGroup.components.add(createSourceModel(ComponentNames.PaymoReader));
        inputGroup.components.add(createSourceModel(ComponentNames.CrunchyDataILReader));
        inputGroup.components.add(createSourceModel(ComponentNames.NeonILReader));
        inputGroup.components.add(createSourceModel(ComponentNames.CrunchyDataCDCReader));
        inputGroup.components.add(createSourceModel(ComponentNames.NeonCDCReader));
        inputGroup.components.add(createSourceModel(ComponentNames.WorkdayReader));
        inputGroup.components.add(createSourceModel(ComponentNames.SpannerDatabaseReader));

        inputGroup.isExpanded = false;

        var enrichmentGroup = collection.add(
            new PredefinedComponentGroup({
                id: "enrichmentGroup",
                name: "Enrichers"
            })
        );
        enrichmentGroup.components.add(createEnrichmentModel(ComponentNames.DBCache));
        enrichmentGroup.components.add(createEnrichmentModel(ComponentNames.FileCache));
        enrichmentGroup.components.add(createEnrichmentModel(ComponentNames.HDFSCache));
        enrichmentGroup.components.add(createExternalEnrichmentModel(ComponentNames.DBExternalCache));

        var processingGroup = collection.add(
            new PredefinedComponentGroup({
                id: "processingGroup",
                name: "Processors"
            })
        );
        processingGroup.components.add(createProcessingModel(ComponentNames.ContinuousQuery, "CQ"));
        processingGroup.components.add(createProcessingModel(ComponentNames.BaseRouter, "ROUTER"));
        processingGroup.components.add(createProcessingModel(ComponentNames.Window, "WINDOW"));

        // Transformation
        var transformationGroup = collection.add(
            new PredefinedComponentGroup({
                id: "transformationGroup",
                name: "Event Transformers"
            })
        );
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldAdder, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationMasking, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldRemover, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldRenamer, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldSplitter, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldEnricher, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldTypeModifier, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationFieldFilter, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationJsonReader, "CQ"));
        transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationShield, "CQ"));
        // transformationGroup.components.add(createProcessingModel(ComponentNames.TransformationSentinel, "SENTINEL"));
        transformationGroup.components.add(
            createProcessingModel(ComponentNames.TransformationTypedEventToWaDbEvent, "CQ")
        );

        const isAppAdapter = securityService.isAppAdapterLicense();

        if (!isAppAdapter) {
            var dbTransformationGroup = collection.add(
                new PredefinedComponentGroup({
                    id: "dbTransformationGroup",
                    name: "DB Event Transformers"
                })
            );

            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeAddUserData, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeDataModifier, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeMetaFilter, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeOperatorFilter, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeDbTableFilter, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeToTypedEvent, "CQ")
            );
            dbTransformationGroup.components.add(
                createProcessingModel(ComponentNames.TransformationWaeToDwStage, "CQ")
            );
        }

        var outputGroup = collection.add(
            new PredefinedComponentGroup({
                id: "outputGroup",
                name: "Targets"
            })
        );
        outputGroup.components.add(createOutputModel(ComponentNames.AzureBlobWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.AzureDataLakeStoreGen2));
        outputGroup.components.add(createOutputModel(ComponentNames.AzureEventHubWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.AzurePostgreSqlWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.AzureSQLDWHWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.BigQuery));
        outputGroup.components.add(createOutputModel(ComponentNames.CassandraWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.ClouderaHiveWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.CloudSqlPostgreSqlWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.CloudSqlMySqlWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.CloudSqlSQLServerWriter));
        outputGroup.components.add(
            createOutputModel(ComponentNames.CosmosDBWriter),
            isCosmosLicense ? { at: 0 } : undefined
        );
        outputGroup.components.add(
            createOutputModel(ComponentNames.CassandraCosmosDBWriter),
            isCosmosLicense ? { at: 0 } : undefined
        );
        outputGroup.components.add(
            createOutputModel(ComponentNames.MongoCosmosDBWriter),
            isCosmosLicense ? { at: 0 } : undefined
        );
        // outputGroup.components.add(createOutputModel(ComponentNames.CouchDBWriter));
        outputGroup.components.add(createBaseModel(ComponentNames.BaseTarget, "TARGET"));
        outputGroup.components.add(createOutputModel(ComponentNames.Database));
        outputGroup.components.add(createOutputModel(ComponentNames.Email));
        outputGroup.components.add(createOutputModel(ComponentNames.FabricDataWarehouseWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.FabricLakehouseFileWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputFile));
        outputGroup.components.add(createOutputModel(ComponentNames.GCSWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.GooglePubSubWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HazelcastWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HBase));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputHDFS));
        outputGroup.components.add(createOutputModel(ComponentNames.HDInsightHDFSWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HDInsightKafkaWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HiveWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HTTPWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HortonWorksHiveWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputJMS));
        outputGroup.components.add(createOutputModel(ComponentNames.JPAWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputKafka2_1_0));
        outputGroup.components.add(createOutputModel(ComponentNames.KinesisWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.KuduWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MapRDBWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MapRStreamWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MapRFSWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MariaDBDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.MongoDbWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputMemSQLDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.Yellowbrick));
        outputGroup.components.add(createOutputModel(ComponentNames.Db2Zos));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputMQTT));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputMySQLDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputOracleDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputPostgresDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputHPSQLMXDatabase));
        outputGroup.components.add(createOutputModel(ComponentNames.RedSh));
        outputGroup.components.add(createOutputModel(ComponentNames.SAPHANAWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.Slack));
        outputGroup.components.add(createOutputModel(ComponentNames.SalesforceWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.TeamsAlertAdapter));
        outputGroup.components.add(createOutputModel(ComponentNames.SnowflakeWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.DeltaLakeWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.SpannerWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.SpannerPGDialectWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.S3));
        outputGroup.components.add(createOutputModel(ComponentNames.OutputSQLServerDatabase));
        // outputGroup.components.add(createOutputModel(ComponentNames.SMS));
        outputGroup.components.add(createOutputModel(ComponentNames.SysOut));
        outputGroup.components.add(createOutputModel(ComponentNames.WActionStore, "WACTIONSTORE"));
        outputGroup.components.add(createOutputModel(ComponentNames.WebAlertUI));
        outputGroup.components.add(createOutputModel(ComponentNames.ServiceNowWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MicrosoftDataverseWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.ClickHouseWriter));
        //DO-NOT-REMOVE-BELOW-COMMENT
        //add-new-writer
        outputGroup.components.add(createOutputModel(ComponentNames.SalesforceMarketingCloudWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.FabricMirrorWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.VerticaWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.IcebergWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.GCPLakehouseWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MicrosoftDynamics365BusinessCentralWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.MicrosoftDynamics365Writer));
        outputGroup.components.add(createOutputModel(ComponentNames.CrunchyDataWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.NeonWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.HubSpotWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.LakebaseWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.S3TablesWriter));
        outputGroup.components.add(createOutputModel(ComponentNames.FirestoreWriter));

        var baseGroup = collection.add(
            new PredefinedComponentGroup({
                id: "baseGroup",
                name: "Base Components"
            })
        );
        baseGroup.components.add(createBaseModel(ComponentNames.BaseSource, "SOURCE"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseExternalSource, "EXTERNALSOURCE"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseCache, "CACHE"));
        //TODO: EventTable - icon should be updated
        baseGroup.components.add(createBaseModel(ComponentNames.BaseEventTable, "CACHE"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseWindow, "WINDOW"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseRouter, "ROUTER"));

        baseGroup.components.add(createBaseModel(ComponentNames.BaseProcessComponent, "OPENPROCESSOR"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseStream, "STREAM"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseCQ, "CQ"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseTarget, "TARGET"));
        baseGroup.components.add(createBaseModel(ComponentNames.BaseWActionStore, "WACTIONSTORE"));
        baseGroup.components.add(createBaseModel(ComponentNames.DBExternalCache, "EXTERNALCACHE"));

        const externalSourceGroup = collection.add(
            new PredefinedComponentGroup({ id: "externalSourceGroup", name: "External Sources" })
        );
        externalSourceGroup.components.add(createExternalSourceModel(ComponentNames.AvroDebezium, "EXTERNALSOURCE"));
        externalSourceGroup.components.add(
            createExternalSourceModel(ComponentNames.AvroExternalDb2zOS, "EXTERNALSOURCE")
        );
        externalSourceGroup.components.add(
            createExternalSourceModel(ComponentNames.BaseExternalSource, "EXTERNALSOURCE")
        );

        return collection;
    },

    licenseValidation: function(collection) {
        collection.each(function(groupModel) {
            groupModel.components.each(function(componentModel) {
                // Force enable these components
                if (
                    componentModel.get("componentID") ===
                        ComponentNames.TransformationSentinel[ComponentKeys.ComponentName] ||
                    componentModel.get("componentID") === ComponentNames.Euclid[ComponentKeys.ComponentName]
                ) {
                    componentModel.set("isEnabled", true);
                    return;
                }
                if (componentModel.get("componentID") === ComponentNames.Sherlock[ComponentKeys.ComponentName]) {
                    componentModel.set("isEnabled", false);
                    return;
                }
                var returnObj = { metaObject: { autoProperties: {} } };
                predefinedComponentProcessor.process(
                    componentModel.get("componentType"),
                    returnObj,
                    null,
                    componentModel.get("name")
                );
                if (
                    (componentModel.get("componentType") === "SOURCE" ||
                        componentModel.get("componentType") === "TARGET") &&
                    componentModel.get("id").indexOf("base-") === -1
                ) {
                    if (returnObj.metaObject.autoProperties.adapter) {
                        let adapterTypeFull = returnObj.metaObject.autoProperties.adapter.handler;
                        let adapterType = adapterTypeFull.replace("Global.PROPERTYTEMPLATE.", "");
                        let enabled = securityCheck.checkWithLicenseValidation(adapterType, componentModel.name);
                        componentModel.isEnabled = !!enabled;
                    }
                } else {
                    let licenseData = PredefinedComponentsDataSource._getLicenseData(
                        componentModel.get("componentType"),
                        componentModel.get("id")
                    );

                    componentModel.set(
                        "isEnabled",
                        PredefinedComponentsDataSource._handleNotAvailableFeatures(licenseData)
                    );
                }
            });
        });
    },
    _handleNotAvailableFeatures: function({ availableInLicense }) {
        return !!availableInLicense;
    },
    _getLicenseData: function(componentType, id) {
        const data = { licenseType: "", availableInLicense: true, variant: undefined };

        if (id === "base-Event-Table") {
            data.licenseType = addonFeaturesKeys.EVENT_TABLE;
        } else {
            switch (componentType) {
                case utils.ENTITIES.CACHE:
                    data.licenseType = addonFeaturesKeys.CACHE;
                    break;
                case utils.ENTITIES.EXTERNALCACHE:
                    data.licenseType = addonFeaturesKeys.EXTERNAL_CACHE;
                    break;
                case utils.ENTITIES.OPENPROCESSOR:
                    data.licenseType = addonFeaturesKeys.OPENPROCESSOR;
                    break;
                case utils.ENTITIES.ROUTER:
                    data.licenseType = addonFeaturesKeys.ROUTER_COMP;
                    break;
                case utils.ENTITIES.WACTIONSTORE:
                    data.licenseType = addonFeaturesKeys.WACTION_STORE;
                    break;
                case utils.ENTITIES.WINDOW:
                    data.licenseType = addonFeaturesKeys.WINDOWS;
                    break;
                case utils.ENTITIES.EVENT_TABLE:
                    data.licenseType = addonFeaturesKeys.EVENT_TABLE;
                    break;
            }
        }
        if (data.licenseType) {
            data.availableInLicense = securityService.isSegmentationFeatureEnabled(data.licenseType);
            data.variant = securityService.getSegmentationVariant(data.licenseType);
        }

        return data;
    },

    loadReact: function() {
        const baseCollection = this.load();

        this.licenseValidation(baseCollection);

        // Merging some groups
        baseCollection.each(function(groupModel) {
            if (["DB Event Transformers", "Processors"].indexOf(groupModel.attributes.name) !== -1) {
                groupModel.attributes.name = "Event Transformers";
                groupModel.attributes.id = "transformationGroup";
            }
        });
        const grouped = _.groupBy(baseCollection.models, item => item.get("name"));

        const mapped = Object.values(grouped).map(sameGroup => {
            const otherSubCategories = {};
            const allComponents = [];
            let categoryName = "unknown";
            let categoryType = "unknown";

            sameGroup.forEach(el => {
                const groupID = el.id;
                const allComponentsInSameGroup = el.attributes.components.map(component => {
                    const parsedComponent = {
                        type: component.attributes.componentType,
                        name: component.attributes.name,
                        isEnabled: component.attributes.isEnabled,
                        id: component.attributes.componentID
                    };

                    const category = _.startCase(_.camelCase(component.attributes.category));

                    if (category && !["baseGroup", "externalSourceGroup", "agentsGroup"].includes(groupID)) {
                        if (!otherSubCategories[category]) {
                            otherSubCategories[category] = [parsedComponent];
                        } else {
                            otherSubCategories[category].push(parsedComponent);
                        }
                    }

                    return parsedComponent;
                });

                categoryName = el.attributes.name;
                categoryType = el.attributes.id;

                allComponents.push(...allComponentsInSameGroup);
            });

            return {
                ...parseCategoryName(categoryName),
                categoryType: categoryType,
                subcategories: [
                    // todo recently used
                    ...Object.keys(otherSubCategories).map(otherCategory => ({
                        name: getPreservedCategoryName(otherCategory),
                        components: otherSubCategories[otherCategory]
                    })),
                    {
                        name: allSubcategoryName,
                        components: allComponents
                    }
                ].sort((a, b) => {
                    // Base always first
                    if (a.name === "Base") return -1;
                    if (b.name === "Base") return 1;

                    // All always last
                    if (a.name === allSubcategoryName) return 1;
                    if (b.name === allSubcategoryName) return -1;

                    // Otherwise sort alphabetically
                    return a.name.localeCompare(b.name);
                })
            };
        });

        const orderMap = ["Source", "Target", "Transform", "DB Transform", "Enrich", "Base"];
        mapped.sort((a, b) => orderMap.indexOf(a.categoryLabel) - orderMap.indexOf(b.categoryLabel));
        return mapped;
    }
};

export const allSubcategoryName = "All";

function createSourceModel(element) {
    return createElement("input", element, "SOURCE");
}

function createEnrichmentModel(element) {
    return createElement("enrichment", element, "CACHE");
}

function createExternalEnrichmentModel(element) {
    return createElement("enrichment", element, "EXTERNALCACHE");
}

function createProcessingModel(element, componentType) {
    return createElement("processing", element, componentType);
}

function createOutputModel(element, componentType) {
    return createElement("output", element, componentType || "TARGET");
}

function createBaseModel(element, componentType) {
    return createElement("base", element, componentType, "");
}
function createExternalSourceModel(element) {
    return createElement("externalSource", element, "EXTERNALSOURCE");
}

function createElement(type, element) {
    try {
        return new PredefinedComponent({
            id: type + "-" + element[ComponentKeys.HumanReadableName]?.replace(new RegExp(" ", "g"), "-"),
            name: element[ComponentKeys.HumanReadableName],
            componentType: element[ComponentKeys.Type],
            componentID: element[ComponentKeys.ComponentName],
            iconClass: element[ComponentKeys.ImageID],
            category: element[ComponentKeys.Category],
            tooltip: "",
            version: element.version
        });
    } catch (e) {
        console.error("Error while creating component:", type, element);
    }
}

function parseCategoryName(name) {
    switch (name) {
        case "Base Components":
            return {
                categoryLabel: "Base",
                categorySearchSuffix: "Base Components"
            };
        case "Sources":
            return {
                categoryLabel: "Source",
                categorySearchSuffix: "Sources",
                categoryTooltip: "Sources ingest real-time data from an external system into the streaming pipeline."
            };
        case "Targets":
            return {
                categoryLabel: "Target",
                categorySearchSuffix: "Targets",
                categoryTooltip:
                    "Targets send processed streaming data from the pipeline to an external system or storage."
            };
        case "Event Transformers":
            return {
                categoryLabel: "Transform",
                categorySearchSuffix: "Transformations",
                categoryTooltip: "Modify, filter, or enrich streaming data as it flows through the pipeline."
            };
        case "DB Event Transformers":
            return {
                categoryLabel: "DB Transform"
            };
        case "Processors":
            return {
                categoryLabel: "Processor",
                categorySearchSuffix: "Processors"
            };
        case "Enrichers":
            return {
                categoryLabel: "Enrich",
                categorySearchSuffix: "Enrichers",
                categoryTooltip:
                    "Enrich streaming data with reference information using in-memory storage for fast lookups and joins"
            };
        case "AI Agents":
            return {
                categoryLabel: "AI Agents",
                categorySearchSuffix: "AI Agents",
                categoryTooltip: "AI Agents for prediction and analysis"
            };
        default:
            return {
                categoryLabel: name
            };
    }
}
function getPreservedCategoryName(categoryName) {
    const preserveredCategoryMapping = {
        "Db Event Transformers": "DB Event Transformers"
    };
    return preserveredCategoryMapping[categoryName] ?? categoryName;
}
const AI_AGENTS = ["foreseer", "euclid", "sherlock", "sentinel"];

const aiAgentsRegex = new RegExp(`(${AI_AGENTS.join("|")})`, "i");

const defaultColor = "#EBF2FA"; // Greyscale.100
export const getIconBackgroundByType = (name, type) => {
    if (!type) return defaultColor;

    if (aiAgentsRegex.test(name)) return "linear-gradient(90deg,#F317791a 0%, #7930D91a 53%, #0C6FE81a 100%)";

    // "1a" suffix is transparency 10%
    switch (type) {
        // Transformers
        case "ROUTER":
        case "WINDOW":
        case "CQ":
            return "#C7784C1a";
        case "SENTINEL":
            return "linear-gradient(90deg,#F317791a 0%, #7930D91a 53%, #0C6FE81a 100%)";

        // Enriches
        case "CACHE":
        case "EXTERNALCACHE":
            return "#6765C31a";

        default:
            return defaultColor;
    }
};

export default PredefinedComponentsDataSource;
